module.exports = __webpack_public_path__ + "static/img/4.a7461b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/4.png
// module id = 3hpV
// module chunks = 19